import { Flex } from "@chakra-ui/react";
import { Icon } from "assets/Icon";
import { Avatar } from "components/RFQ/Avatar";
import { Button } from "newui/components/Button";
import NotFoundDatas from "components/RFQ/NotFoundDatas/NotFoundDatas";
import { LoadingSpinner } from "components/Loading/LoadingSpinner";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "components/RFQ/Table";
import React from "react";
import tw, { styled, css } from "twin.macro";
import { DEFAULT_IMAGE_AVATAR } from "utils/constants";

const ListViewStyled = styled.div(() => [
	tw`py-8`,
	css`
		.title {
			font-weight: 500;
			font-family: Roboto;
			font-size: 14px;
		}

		.text {
			font-weight: 400;
			font-family: Roboto;
			font-size: 14px;
		}
	`,
]);

const ListViewSupplier = React.memo(
	({
		supplierLists,
		invitedSuppliers,
		handleInviteSupplier,
		handleRemoveSupplier,
		handleSelectAll,
		handleDeselectAll,
		isLoading = false,
	}) => {
		// Get suppliers from supplierLists if it's an array, otherwise use empty array
		const suppliers = Array.isArray(supplierLists) ? supplierLists : [];
		const allSelected = suppliers.length > 0 && invitedSuppliers?.length === suppliers.length;

		const isInvited = (id) => invitedSuppliers.includes(id);
		const onClickSelectHandler = (id) => {
			if (!isInvited(id)) {
				handleInviteSupplier(id);
			} else {
				handleRemoveSupplier(id);
			}
		};

		if (isLoading) {
			return <LoadingSpinner />;
		}

		return (
			<ListViewStyled>
				{suppliers.length > 0 && (
					<div className="mb-4 flex items-center justify-between">
						<label className="flex cursor-pointer items-center gap-2">
							<div className="relative">
								<input
									type="checkbox"
									className="sr-only"
									checked={allSelected}
									onChange={allSelected ? handleDeselectAll : handleSelectAll}
								/>
								<div className={`h-5 w-9 rounded-full transition-colors ${allSelected ? "bg-royal-blue" : "bg-gray-300"}`} />
								<div className={`absolute left-0.5 top-0.5 h-4 w-4 rounded-full bg-white shadow transition-transform ${allSelected ? "translate-x-4" : ""}`} />
							</div>
							<span className="text-sm font-medium text-tertiary-700">Select All</span>
						</label>
						<span className="text-sm text-tertiary-600">
							{invitedSuppliers?.length || 0} of {suppliers.length} selected
						</span>
					</div>
				)}
				<Table containerClass={tw`w-full border rounded-md drop-shadow-xl`}>
					<TableHeader>
						<TableRow>
							<TableHead firstCol={true}>
								<div
									className="flex"
									style={{ gap: "8px", alignItems: "center" }}
								>
									Supplier
								</div>
							</TableHead>
							<TableHead className={tw`max-w-[400px]`}>Name</TableHead>
							<TableHead className={tw`max-w-[218px]`}>Email</TableHead>
							<TableHead className={tw`max-w-[68px]`}>
								<div className="hidden">Icon</div>
							</TableHead>
						</TableRow>
					</TableHeader>
					<TableBody>
						{suppliers.length > 0 ? (
							suppliers.map((supplier, index) => (
								<TableRow key={supplier.id}>
									<TableCell className={tw`min-w-[250px]`}>
										<div
											className="flex gap-3"
											style={{
												alignItems: "center",
												gap: "8px",
											}}
										>
											<Avatar
												avatar={supplier?.logo_path || DEFAULT_IMAGE_AVATAR}
											/>
											<p className="title">{supplier?.name || "-"}</p>
										</div>
									</TableCell>
									<TableCell>
										<p className="text">{supplier?.contact_name || "-"}</p>
									</TableCell>
									<TableCell>
										<p className="text">{supplier?.email || "-"}</p>
									</TableCell>
									<TableCell>
										<Flex
											className="my-3"
											gap={4}
											align={"center"}
											float={"right"}
										>
											<div>
												<Button
													btntype="secondary"
													className="btn-company-profile-wrapper"
													as="a"
													target="_blank"
													href={`/company/${supplier?.id}`}
													style={{ border: "none" }}
												>
													<Flex
														gap={2}
														className="btn-company-profile items-center"
													>
														Company Profile
													</Flex>
												</Button>
											</div>
											<div>
												<Button
													type="button"
													btntype={
														isInvited(supplier.id) ? "primary" : "secondary"
													}
													onClick={() => onClickSelectHandler(supplier?.id)}
													style={{ width: "100%" }}
												>
													{isInvited(supplier.id) ? (
														<Flex
															gap={2}
															className="btn-selected items-center justify-center text-center"
														>
															Selected
															<Icon icon="check-only" />
														</Flex>
													) : (
														<Flex
															gap={2}
															className="btn-selected items-center justify-center text-center"
														>
															Select
														</Flex>
													)}
												</Button>
											</div>
										</Flex>
									</TableCell>
								</TableRow>
							))
						) : (
							<TableRow className="col-span-5 h-[500px]">
								<div className="absolute left-2/4 -translate-x-2/4">
									<NotFoundDatas
										text={`No supplier found`}
										description={`The supplier list is empty and needs suppliers to create a RFx`}
									/>
								</div>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</ListViewStyled>
		);
	}
);

export default ListViewSupplier;
